import Api from '../api'

export default {
    getJobs(server) {
        return Api.get(`/JobApi/GetJobs?server=${server}`)
    }
}